import React from 'react';
import Button from '../../Button/Button';

function TestimonialSection() {
  return (
        <>
            <section className="section-pad overflow-hidden testimonial md:mt-0 bg-[#fff]">
                <div className="container mx-auto px-2 py-[50px] md:py-[100px]">
                    <div className="flex items-center justify-center">
                        <img src="../img/us/testimonial_icon.webp" alt="celent testimonial" className="w-[40px]"/>
                    </div>
                    
                    <h3 className="uppercase text-center text-[#212121] text-16 tracking-[1.2px] pb-1 pt-4 font-secondary leading-6" data-aos="fade-up">Winning Celent’s Prestigious Advanced Functionality Ranking...</h3>
                    <h2 className="font-secondary text-[#212121] text-center text-[20px] md:text-[32px] font-medium tracking-normal leading-[26px] md:leading-[44px] w-full md:w-4/5 mx-auto opacity-80 pt-3 p-2" data-aos="fade-up">Vymo's compliance solution, powered by AI and Gen AI, not only enhances productivity but also fosters innovation. This recognition underscores Vymo's unwavering dedication to delivering exceptional technology solutions for the insurance industry.</h2>

                    <p className="text-16 text-[#212121] text-center opacity-90 pt-3 font-medium" data-aos="fade-up">Karlyn Carnahan, Head of Insurance, North America</p>
                    
                    <div className="flex items-center justify-center pb-0 md:pb-[50px] pt-1"  data-aos="fade-up">
                        <img src="../img/us/testimonial_celent.webp" alt="celent logo" className="w-[140px]"/>
                    </div>
                </div>
            </section>
            <section className="section-pad overflow-hidden md:mt-0 bg-[#dac2ae] !pb-[5px] !pt-[30px]">
                <div className="container mx-auto px-3">
                    <div className="flex flex-col lg:flex-row items-center lg:items-start gap-0 md:gap-4 mt-6 pt-1">
                        <div className="text-left w-full md:w-2/3" data-aos="fade-up" data-aos-delay="200">
                            <img src="../img/us/quote.png" className="w-[46px]"/>
                            <h3 className="uppercase text-left text-[#212121] text-16 tracking-[1.2px] pb-1 pt-4.5 font-secondary leading-6">PARTNERS WHO TRUST VYMO</h3>
                            <h2 className="font-secondary text-[#212121] text-left text-[26px] md:text-[32px] font-medium tracking-normal leading-[26px] md:leading-[44px] pt-4 md:pr-4">Vymo is fundamentally changing the way financial services work</h2>

                            <p className="text-16 text-[#212121] text-left opacity-70 pt-5 font-medium">Karlyn Carnahan, Head of Insurance, North America</p>

                            <img src="../img/us/microsoft.webp" alt="microsoft logo" className="w-[140px] -ml-1"/>

                        </div>
                        <div className="text-left w-full md:w-1/3" data-aos="fade-up" data-aos-delay="200">
                            <img src="../img/us/mirco_ceo.webp" className="w-full -mb-2 md:-mb-1"/>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default TestimonialSection;